<template>
  <div class="home-index" v-show="!loading">
    <RouterView />
    <div class="footer">
      <div class="copy container">
        <!-- 版权所有 -->
        <p style="font-size: 14px; margin-top: 5px;">&copy; 2026 青蛙计划。保留所有权利。</p>

        <!-- 个人网站的可选补充：友情免责 -->
        <p style="font-size: 14px; margin-top: 5px;">
          本站内容仅供学习交流，如有侵权请联系删除。
        </p>
        <p style="font-size: 14px; margin-top: 5px;">
          <!-- <a href="https://beian.mps.gov.cn/" target="_blank">
            <img src="#" alt="公安备案图标">
            公安备案号
          </a> -->
          <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2023038551号-5</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, provide, ref } from 'vue'
import request from '@/utils/request'

export default {
  name: 'HomeIndex',
  setup () {
    const loading = ref(true)
    const articles = ref([])
    const totalpage = ref(0)
    const islastpage = ref(false)
    const currentPage = ref(1)
    const categories = ref([])

    const fetchData = async () => {
      try {
        const [articleRes, categoryRes] = await Promise.all([
          request('/article/all', 'get', { nextpage: currentPage.value }),
          request('/article/category', 'get', {})
        ])
        articles.value = articleRes.data.articles
        totalpage.value = articleRes.data.totalpage
        islastpage.value = articleRes.data.islastpage
        categories.value = categoryRes.categories
      } catch (err) {
        console.error('数据加载失败', err)
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      fetchData()
    })

    provide('articleData', { articles, totalpage, islastpage, currentPage, categories })

    // // 全部数据在父节点请求，并使用provide和inject注入
    // const doneLoading = () => {
    //   loading.value = false
    // }
    // provide('doneLoading', doneLoading)
    return {
      loading
    }
  }
}
</script>

<style lang="less" scoped>
.home-index {
  // scrollbar-color: rgb(226, 226, 226) ;
  background-color: @backgroundColor;
  // background-color: rgb(245, 242, 240);
  overflow-x: hidden;
  overflow-y: auto;
  height: 100vh;
}

.footer {
  height: 200px;
  // width: 100vh;
  // background-color: antiquewhite;
  background-color: rgb(255, 255, 255);
  padding: 20px 20px;
  .copy {
    margin: auto auto;
  }
  @media (max-width: 768px) {
    height: 150px;
  }
}

</style>>
